import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../authorization/services/auth.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MessagingServiceService {
  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) {}

  getIncomingMessages(): Observable<IncomingMessage[]> {
    var employeeId = this.authService.getCurrentUser().id;
    return this.apiService.get(
      'Message/IncomingMessages?employeeId=' + employeeId
    );
  }

  getOutgoingMessages(): Observable<OutgoingMessages[]> {
    var employeeId = this.authService.getCurrentUser().id;
    return this.apiService.get(
      'Message/OutgoingMessages?employeeId=' + employeeId
    );
  }

  createMessage(createMessage: CreateMessage): Observable<boolean> {
    createMessage.senderId = this.authService.getCurrentUser().id;
    return this.apiService.post('Message/Create', createMessage);
  }

  getActiveDrivers(): Observable<ActiveDriver[]> {
    return this.apiService.get('Drivers/activeDriversForSelcetion');
  }

  getActiveCrafts(): Observable<ActiveCrafts[]> {
    return this.apiService.get('Crafts');
  }

  markMessageAsRead(messageId: number): Observable<boolean> {
    return this.apiService.post('Message/Read?messageId=' + messageId);
  }
}

export interface ActiveDriver {
  id: number;
  fullName: string;
}

export interface ActiveCrafts {
  id: number;
  craftNr: string;
}

export interface IncomingMessage {
  messageText: string;
  senderName: string;
  status: MessageStatus;
  id: number;
  sendDateTime: Date;
}


export interface OutgoingMessages {
  messageText: string;
  recipientName: string;
  status: MessageStatus;
  id: number;
  sendDateTime: Date;
}

export interface CreateMessage {
  messageText: string;
  senderId: number;
  recipients: Recipients[];
}

export interface Recipients {
  recipientType: string;
  recipientId: number;
}

export enum MessageStatus {
  Read = "Read",
  Delivered = "Delivered",
  Undelivered = "Undelivered"
}
